
import { Prop, Watch } from "vue-property-decorator";
import { Options } from "vue-class-component";
import LineChart from "../molecules/LineChart.vue";
import FieldLabel from "../atoms/FieldLabel.vue";
import HelpIcon from "../atoms/HelpIcon.vue";
import { ChartData, GraphData } from "../pages/Progress.vue";
import { GraphColors } from "../../helpers/const";
import ChartMixin from "../../helpers/mixins/chart";
import { ChartOptions } from "chart.js";

@Options({
  components: {
    LineChart,
    FieldLabel,
    HelpIcon
  }
})
export default class ProgressChart extends ChartMixin {
  @Prop({ required: true, type: String }) id?: string;
  @Prop({ required: true, type: Object }) chartData?: ChartData;
  @Prop({ required: true, type: Object }) options?: ChartOptions;
  @Prop({ type: Object }) height: number | string = "auto";
  @Prop({ required: true, type: Boolean }) hideScoreDiff: boolean = false;
  scoreDiffs: number[][] = [];

  get graphColors() {
    return GraphColors;
  }
  rerenderChart() {
    (this.$refs[`chart${this.id}`] as LineChart).rerenderChart();
  }
  @Watch("chartData.datas", { deep: true, immediate: true })
  updateScoreDiffs() {
    this.scoreDiffs = [];
    if (!this.chartData || this.chartData.examDate.length <= 1 || this.hideScoreDiff) {
      return;
    }
    const latestDate = this.chartData.examDate.sort((a, b) => (a > b ? -1 : 1))[0];
    const latestDataset = (this.chartData.datas as GraphData).datasets.find(dataset => dataset.label.includes(latestDate));
    const comparingDatasets = (this.chartData.datas as GraphData).datasets.filter(dataset => !dataset.label.includes(latestDate));

    comparingDatasets.map((dataset, i) => {
      this.scoreDiffs.push([]);
      dataset.data.forEach((score, j) => {
        // 小数点第一位で四捨五入
        this.scoreDiffs[i].push(Math.round((score as number) - (latestDataset!.data as number[])[j]));
      });
    });
  }
}
